import pages from "./ja-JP/pages";

export default {
  "navBar.lang": "言語",
  ...pages,
};
